import { getStruct, uploadTrackingData, getPerformanceData } from './event-tracking';
import { getSessionId } from '$common/utils/session-id';
import storage from '$common/utils/storage';

export { FROM_ID, fromJoin } from './help.js'

export const locationQuery = () => {
  let queries = {};
  try {
    let search = window.location.search.match(/\?.*(?=\b|#)/);
    if (search) {
      search = search[0].replace(/^\?/, "");
    }
    if (search) {
      search.split('&').forEach((item) => {
        const param = item.split('=');
        if (param[1]) {
          queries[param[0]] = decodeURIComponent(param[1])
        }
      });
    }
    if (typeof window?.ssrConfig?.routerConfig?.short?.params === 'object' && !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)) {
      queries = Object.assign({}, queries, window.ssrConfig.routerConfig.short.params);
    }
    return queries;
  } catch (err) {
    console.log("整理参数失败: ", err);
    return {};
  }
};

export const uploadEventList = (eventList, params = {}) => {
  const otherCollectionDatas = []
  const searchQuery = locationQuery() || {}
  for (let i = 0; i < eventList.length; i++) {
    const params = eventList[i]
    let { businessName, eventGroup = 'viewPage', event = 'WebPageViews', ext = {}, loginName, operatorNo = undefined, longitude = undefined, latitude = undefined } = params;
    const extendObj = {}
    loginName = loginName || storage.getItem('loginName')
    operatorNo = operatorNo || storage.getItem('operatorNo')
    console.log('loginName')
    console.log(loginName)
    let channel = ext.channel ? ext.channel : (searchQuery?.channel ?? 'blank')
    ext.from = ext.from || searchQuery.from || ''
    if (channel === 'null' || channel === 'undefined') {
      channel = 'blank'
    }

    // 过滤空参数，以免签名不正确
    Object.keys(ext).forEach(key => {
      if (ext[key] || typeof ext[key] === 'boolean') {
        extendObj[key] = ext[key]
      } 
    })

    // hack: shareChannel是channel的一个下游，用下划线拼在一起，方便数据清洗
    if (extendObj && extendObj.shareChannel) {
      channel = channel + '_' + extendObj.shareChannel
      extendObj.channel = channel
      delete extendObj.shareChannel
    }

    otherCollectionDatas.push(getStruct({
      businessName,
      eventGroup,
      event,
      ext: {
        url: window.location.href,
        channel,
        ...extendObj
      },
      longitude,
      latitude,
      loginName,
      operatorNo
    }))
  }

  return uploadTrackingData({
    otherCollectionDatas, ...params
  }, { success: () => console.log('多埋点上报成功') })
}

//  访问事件埋点
export const pageEvent = (params = {}) => {
  const { businessName, eventGroup = 'viewPage', event = 'WebPageViews', ext = {} } = params;
  const searchQuery = locationQuery();
  return uploadTrackingData({
    otherCollectionDatas: [getStruct({ 
      sessionid: getSessionId(),
      businessName,
      eventGroup,
      event,
      spm: {},
      ext: {
        url: window.location.href,
        channel: searchQuery?.channel ?? 'blank',
        ...getPerformanceData(),
        ...ext
      }
    })]
  }, { success: () => console.log('页面埋点done! ') });
};
//  点击事件埋点
export const clickEvent = (params = {}) => {
  const { businessName, eventGroup = 'click', event = '@click', ext = {}, currentPage, currentArea } = params;
  const searchQuery = locationQuery();
  return uploadTrackingData({
    otherCollectionDatas: [getStruct({ 
      sessionid: getSessionId(),
      businessName,
      eventGroup,
      event,
      spm: { ...(currentPage && { currentPage } || {}), ...(currentArea && { currentArea } || {}) },
      ext: {
        url: window.location.href,
        channel: searchQuery?.channel ?? 'blank',
        ...getPerformanceData(),
        ...ext
      }
    })]
  }, { success: () => console.log('页面埋点done! ') });
};